import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { renderMarkdown } from '~/functions/markdown'


export default /*#__PURE__*/_defineComponent({
  __name: 'SdgTargetsPicker',
  props: {
    value: { default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any[], disabled: boolean };





const selectedSdgTargets = computed<number[]>(() => {
  if (!props.value) return []
  return props.value
    .map((item: any) => (typeof item === 'number' ? item : item?.id))
    .filter((id: unknown): id is number => typeof id === 'number')
})

const selectedSdgs = computed<number[]>(() => {
  if (!props.value) return []
  const sdgIds = props.value
    .map((item: any) => (typeof item === 'number' ? undefined : item?.sdgId))
    .filter((id: unknown): id is number => typeof id === 'number')
  return Array.from(new Set(sdgIds))
})

const selectedSdgTargetsDraft = ref<number[]>([])

return { __sfc: true,props, emit, selectedSdgTargets, selectedSdgs, selectedSdgTargetsDraft, renderMarkdown }
}

})